import api from "@/services/api";
import i18n from "@/i18n";

class AuthService {

  login(user) {
    return api.post('auth', {
        login: user.login,
        password: user.password
      }).then(response => {
        if (response.data) {
          if (response.data.roles.includes("ROLE_COUNSELOR") ||
              response.data.roles.includes("ROLE_EXTERNAL_COUNSELOR")) {
            localStorage.setItem('token', JSON.stringify(response.data));
            return response.data;
          } else return Promise.reject(i18n.global.t("app.no_access"))
        }
        return response.data;
      })
  }
  validate(key, email) {
    return api.post('accounts/validate', {
      email: email,
      validationId: key
    }).then(response => {
      return response.data;
    })
  }

  logout() {
    localStorage.removeItem('token');
  }

}

export default new AuthService();
